// Sample menu data for all categories
export const menuData = {
  talak: [
    {
      id: 1,
      name: "Görög Tál",
      description: "Friss hús, ropogós zöldségek, tzatziki szósz és pita kenyér",
      price: "3 980 Ft",
      image: "/img/menu/gorogtal.png",
      badge: "Népszerű",
      ingredients: ["csirkehús", "zöldségek", "tzatziki", "pita"]
    },
    {
      id: 2,
      name: "Sajtos Gyros Tál",
      description: "Eredeti görög gyros hús sajttal, friss saláta és görög szószok",
      price: "4 280 Ft",
      image: "/img/menu/sajtosgyros.png",
      badge: "Népszerű",
      ingredients: ["gyros hús", "sajt", "saláta", "görög szószok"]
    },
    {
      id: 3,
      name: "Sima Gyros Tál",
      description: "Klasszikus görög gyros hús, friss zöldségek és tzatziki",
      price: "3 980 Ft",
      image: "/img/menu/simagyros.jpeg",
      badge: "Klasszikus",
      ingredients: ["gyros hús", "zöldségek", "tzatziki", "feta sajt"]
    },
    {
      id: 4,
      name: "Fullos Gyros Tál",
      description: "Dupla hús, extra sajt, bacon és friss zöldségek",
      price: "4 580 Ft",
      image: "/img/menu/fullosgyros.jpeg",
      badge: "Különlegesség",
      ingredients: ["dupla hús", "extra sajt", "bacon", "zöldségek"]
    }
  ],
  boxok: [
    {
      id: 5,
      name: "Csirke Box",
      description: "Grillezett csirkemell, friss saláta és tzatziki szósz",
      price: "3 680 Ft",
      image: "/img/menu/simagyrosbox.jpeg",
      badge: "Egészséges",
      ingredients: ["csirkemell", "saláta", "tzatziki", "zöldségek"]
    },
    {
      id: 6,
      name: "Sajtos Gyros Box",
      description: "Eredeti görög gyros hús sajttal, friss zöldségek és görög szószok",
      price: "4 180 Ft",
      image: "/img/menu/sajtosgyrosbox.jpeg",
      badge: "Népszerű",
      ingredients: ["gyros hús", "sajt", "zöldségek", "görög szószok"]
    },
    {
      id: 7,
      name: "Fullos Gyros Box",
      description: "Dupla hús, extra sajt, bacon és friss zöldségek",
      price: "4 680 Ft",
      image: "/img/menu/fullosgyrosbox.jpeg",
      badge: "Különlegesség",
      ingredients: ["dupla hús", "extra sajt", "bacon", "zöldségek"]
    }
  ],
  pitak: [
    {
      id: 9,
      name: "Görög Pita",
      description: "Friss pita kenyér, hús, zöldségek és tzatziki szósz",
      price: "2 480 Ft",
      image: "/img/menu/gorogpita.jpeg",
      badge: "Népszerű",
      ingredients: ["pita kenyér", "hús", "zöldségek", "tzatziki"]
    },
    {
      id: 10,
      name: "Gyros Pita",
      description: "Eredeti görög gyros hús, friss zöldségek és tzatziki",
      price: "2 680 Ft",
      image: "/img/menu/gyrospita.jpeg",
      badge: "Klasszikus",
      ingredients: ["gyros hús", "zöldségek", "tzatziki", "pita"]
    },
    {
      id: 11,
      name: "Sajtos Görög Pita",
      description: "Eredeti görög gyros hús sajttal, friss zöldségek és görög szószok",
      price: "2 880 Ft",
      image: "/img/menu/sajtosgorogpita.jpeg",
      badge: "Különlegesség",
      ingredients: ["gyros hús", "sajt", "zöldségek", "görög szószok"]
    }
  ],
  uditok: [
    {
      id: 21,
      name: "Őszibaracklé",
      description: "Rostos gyümölcslé",
      price: "790 Ft",
      image: "/img/menu/gyumolcsle.png",
      badge: "Egészséges",
      ingredients: ["friss őszibarack", "jég", "cukor"]
    },
    {
      id: 22,
      name: "Görög kávé",
      description: "Hagyományos főzet",
      price: "890 Ft",
      image: "/img/menu/gorogkave.png",
      badge: "Népszerű",
      ingredients: ["görög kávé", "cukor", "víz"]
    },
    {
      id: 23,
      name: "Ayran",
      description: "Sós joghurtital",
      price: "890 Ft",
      image: "/img/menu/ayran.png",
      badge: "Tradicionális",
      ingredients: ["joghurt", "só", "víz", "menta"]
    },
    {
      id: 24,
      name: "Házi limonádé",
      description: "Friss citrommal, jéggel",
      price: "990 Ft",
      image: "/img/menu/limonade.png",
      badge: "Frissítő",
      ingredients: ["citrom", "cukor", "menta", "jég"]
    }
  ],
  desszertek: [
    {
      id: 25,
      name: "Baklava",
      description: "Eredeti görög baklava dióval és mézzel",
      price: "1 280 Ft",
      image: "/img/menu/baklava.jpg",
      badge: "Tradicionális",
      ingredients: ["dió", "méz", "filo tészta", "fűszerek"]
    },
    {
      id: 26,
      name: "Görög Joghurt",
      description: "Krém görög joghurt mézzel és friss gyümölcsökkel",
      price: "1 180 Ft",
      image: "/img/menu/gorgjoghurt.png",
      badge: "Egészséges",
      ingredients: ["görög joghurt", "méz", "gyümölcsök", "dió"]
    },
    {
      id: 27,
      name: "Kataifi",
      description: "Görög kataifi desszert dióval és sziruppal",
      price: "1 380 Ft",
      image: "/img/menu/kataifi.jpg",
      badge: "Új",
      ingredients: ["kataifi tészta", "dió", "szirup", "fűszerek"]
    },
    {
      id: 28,
      name: "Tiramisu",
      description: "Olasz tiramisu kávéval és mascarpone sajttal",
      price: "1 480 Ft",
      image: "/img/menu/tiramisu.jpg",
      badge: "Népszerű",
      ingredients: ["mascarpone", "kávé", "kakao", "piskóta"]
    }
  ]
};

export const categories = [
  { id: 'talak', name: 'Tálak', anchor: '#talak' },
  { id: 'boxok', name: 'Boxok', anchor: '#boxok' },
  { id: 'pitak', name: 'Piták', anchor: '#pitak' },
  { id: 'uditok', name: 'Üdítők', anchor: '#uditok' },
  { id: 'desszertek', name: 'Desszertek', anchor: '#desszertek' }
];
